import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import Button from '@oberoninternal/travelbase-ds/components/action/Button';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import Filters from './icons/Filters';
import Modal from '@oberoninternal/travelbase-ds/components/layout/Modal';
import ModalHeader from '@oberoninternal/travelbase-ds/components/layout/ModalHeader';
import Stack from '@oberoninternal/travelbase-website/dist/components/Stack';
import { CheckboxField } from '@oberoninternal/travelbase-ds/components/form/Checkbox';
import { filterTypes } from './pages/Search';
import Formed from '@oberoninternal/travelbase-website/dist/components/Formed';

type Values = Record<string, boolean>;
interface Props<V extends Values> {
    onSetValues: (values: V) => void;
    values: V;
}

const BottomSearch = <V extends Values>({ onSetValues, values }: Props<V>) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Container className="lt-s">
                <StyledButton onClick={() => setModalOpen(true)}>
                    <Filters />
                    <span>
                        <FormattedMessage defaultMessage="Filters" />
                    </span>
                </StyledButton>
            </Container>
            <StyledModal open={modalOpen} onClose={() => setModalOpen(false)}>
                <Formed<V>
                    enableReinitialize
                    initialValues={values}
                    skipPrompt
                    handleSubmit={v => {
                        onSetValues(v);
                        setModalOpen(false);
                    }}
                >
                    {({ setValues }) => (
                        <>
                            <ModalHeader>
                                <FormattedMessage defaultMessage="Filters" />
                            </ModalHeader>
                            <Flex flexDirection="column" justifyContent="space-between" height="100%">
                                <Box py={5}>
                                    <Stack spacing={4}>
                                        {filterTypes.map(filter => (
                                            <CheckboxField key={filter.type} name={filter.type} id={filter.type}>
                                                {filter.label}
                                            </CheckboxField>
                                        ))}
                                    </Stack>
                                </Box>

                                <Stack spacing={4}>
                                    <Button size="large" type="submit">
                                        <FormattedMessage defaultMessage="Filters toepassen" />
                                    </Button>
                                    <ResetFilters
                                        type="submit"
                                        onClick={() => {
                                            setValues(
                                                Object.assign({}, ...filterTypes.map(({ type }) => ({ [type]: false })))
                                            );
                                        }}
                                    >
                                        <FormattedMessage defaultMessage="Filters verwijderen" />
                                    </ResetFilters>
                                </Stack>
                            </Flex>
                        </>
                    )}
                </Formed>
            </StyledModal>
        </>
    );
};

export default BottomSearch;

const ResetFilters = styled.button`
    background: none;
    border: none;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary[80]};
    line-height: 2;
    font-weight: 600;
    font-size: 1.5rem;
`;

const StyledModal = styled(Modal)`
    form {
        // can't style Formed... thanks obama uhh chris.
        height: 100%;
        display: flex;
        flex-direction: column;
    }
`;

const StyledButton = styled(Button).attrs({ variant: 'outline' })`
    height: 100%;
    border-radius: 0.8rem;
    border: 1px solid ${({ theme }) => theme.colors.neutral['20']};
    :active,
    :focus {
        border-color: ${({ theme }) => theme.colors.neutral['40']};
    }
    && {
        background: ${({ theme }) => theme.colors.neutral['5']};
        box-shadow: 0 1.6rem 2.4rem 0 rgba(59, 118, 160, 0.07), 0 2.4rem 8rem 0 rgba(59, 118, 160, 0.1);
    }

    font-size: 10px !important;

    > span {
        display: flex;
        flex-direction: column;
        text-transform: capitalize;
        > * + * {
            margin-left: 0 !important;
            margin-top: 0.5rem;
        }
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        font-size: inherit;
    }
`;

const Container = styled(Flex)`
    position: fixed;
    width: 100vw;
    padding: 0 var(--wrapperPadding);
    height: 5.6rem;
    margin-left: calc(-1 * var(--wrapperPadding));
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${({ theme }) => theme.zIndices.sticky};
    > * + * {
        margin-left: 0.6rem;
    }
    right: 0;
    bottom: 1.2rem;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        height: 6.4rem;
        bottom: 2.4rem;
    }
`;
